import { AIChatBoxMessagesInterceptor, link, linkButton, systemMessage, temporaryText } from '@aston/ai-chat';
import { TranslateService } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { selectConfig } from '../../root-store/app-store/selectors';
import { AppConfiguration } from '../../app.configuration';
import * as R from '../../routes-definitions';

@Injectable({ providedIn: 'any' })
export class MiddleAIChatBoxMessagesInterceptor extends AIChatBoxMessagesInterceptor {
	i18n = inject(TranslateService)
	fatStore = inject(Store)

	config = toSignal(this.fatStore.select(selectConfig), { initialValue: {} as AppConfiguration })

	generateTemporaryButtons(text: string) {
		const buttons = []
		// buttons.push(suggestionButton('Comment le DSO est calculé ?'))

		if (text.match(/DSO/)) {
			buttons.push(linkButton(this.i18n.instant('App.AIChat.Suggestions.GoToChartDSO'), R.getOverviewFullPath(R.DashboardsPageFinancialRoutePath)))
		}
		if (text.match(/Scoring/)) {
			buttons.push(linkButton(this.i18n.instant('App.AIChat.Suggestions.GoToChartRisks'), R.getOverviewFullPath(R.DashboardsPageOperationalRoutePath)))
		}
		if (text.match(/Retard/)) {
			buttons.push(linkButton(this.i18n.instant('App.AIChat.Suggestions.GoToChartDelays'), R.getOverviewFullPath(R.DashboardsPageFinancialRoutePath)))
		}
		if (text.match(/Action/)) {
			buttons.push(linkButton(this.i18n.instant('App.AIChat.Suggestions.GoToDunningActions'), R.getDunningActionsListRouteFullPath()))
		}
		if (text.match(/Group/)) {
			buttons.push(linkButton(this.i18n.instant('App.AIChat.Suggestions.GoToDunningGroups'), R.getDunningGroupsListRouteFullPath()))
		}
		if (text.match(/Sc.nario/)) {
			buttons.push(linkButton(this.i18n.instant('App.AIChat.Suggestions.GoToDunningScenarios'), R.getDunningScenariosListRouteFullPath()))
		}
		if (text.match(/Mod[eè]l/)) {
			buttons.push(linkButton(this.i18n.instant('App.AIChat.Suggestions.GoToDunningTemplates'), R.getDunningTemplatesListRouteFullPath()))
		}

		if (this.isFlakyResponse()) {
			const frb = this.buttonsFromFlakyResponse()

			if (frb.length) frb.forEach(b => buttons.push(b))
			else if (this.flakyResponsesCount() % 5 === 0) {
				const contactUs = this.i18n.instant('Support.Contact')
				const byZoho = this.i18n.instant('Support.TicketUrlText')
				buttons.push(linkButton(`${contactUs} ${byZoho}`, this.config().helpUrl))
			}
		}

		return systemMessage({ html: temporaryText(buttons.join('')) })
	}

	replaceWellKnownTokens(text: string) {
		super.replaceWellKnownTokens(text)

		return text
			.replace(/【[^】]*】/g, '') // remove files references
			.replace(/08\s*90\s*21\s*38\s*39/g, `[08 90 21 38 39](tel:${this.i18n.instant('Support.Phone')})`)
			.replace(/\+33\s*8\s*90\s*21\s*38\s*39/g, `[08 90 21 38 39](tel:${this.i18n.instant('Support.Phone')})`)
			.replace(/support@astonai.com/g, `[${this.i18n.instant('Support.Email')}](mailto:${this.i18n.instant('Support.Email')})`)
			.replace(/ retard/i, ` ${link('retard', R.getOverviewFullPath(R.DashboardsPageFinancialRoutePath))}`)
			.replace(/ DSO /i, ` ${link('DSO', R.getOverviewFullPath(R.DashboardsPageFinancialRoutePath))} `)
			.replace(/ scoring/i, ` ${link('scoring', R.getOverviewFullPath(R.DashboardsPageOperationalRoutePath))})`)
			.replace(/ action /i, ` ${link('action', R.getDunningActionsListRouteFullPath())} `)
			.replace(/ groupe /i, ` ${link('groupe', R.getDunningGroupsListRouteFullPath())} `)
			.replace(/ scénario /i, ` ${link('scénario', R.getDunningScenariosListRouteFullPath())} `)
			.replace(/ modèle /i, ` ${link('modèle', R.getDunningTemplatesListRouteFullPath())} `)
	}
}
